import { __makeTemplateObject, __read } from "tslib";
import { css } from 'emotion';
import React, { Fragment, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { Icon } from '../Icon/Icon';
import { LoadingIcon } from '../LoadingIcon/LoadingIcon';
import { RoutedEntityPage } from './RoutedEntityPage';
export var EntityItemIndexPage = function (_a) {
    var titleProvider = _a.titleProvider, subTitleProvider = _a.subTitleProvider, iconProvider = _a.iconProvider, entityState = _a.entityState, entityStateProvider = _a.entityStateProvider, entityViewer = _a.entityViewer, entityService = _a.entityService;
    var params = useParams();
    var itemId = params['itemId'];
    var _b = __read(useState(undefined), 2), item = _b[0], setItem = _b[1];
    var _c = __read(useState(''), 2), error = _c[0], setError = _c[1];
    var dispatch = useDispatch();
    var Viewer = entityViewer;
    useMemo(function () {
        if (!entityState.isFetched && !entityState.isFetching) {
            dispatch(entityStateProvider.loadState());
        }
        else {
            if (!item) {
                entityService.getById(itemId)
                    .then(function (response) {
                    setItem(response.data);
                    setError('');
                })
                    .catch(function (err) {
                    setError('Item not found!');
                });
            }
        }
    }, [entityState, item, itemId, dispatch]);
    var navModelItem = {
        text: titleProvider({ item: item, pageName: 'view' }),
        subTitle: subTitleProvider({ item: item, pageName: 'view' }),
        icon: iconProvider({ item: item, pageName: 'view' }),
        url: '.'
    };
    var navModel = {
        main: navModelItem,
        node: navModelItem
    };
    return (React.createElement(Fragment, null,
        !item && !error && React.createElement(LoadingIcon, null),
        item && (React.createElement(RoutedEntityPage, { model: navModel },
            React.createElement("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              display: flex;\n              justify-content: end;\n            "], ["\n              display: flex;\n              justify-content: end;\n            "]))) },
                React.createElement(NavLink, { to: "./edit", onClick: function () { setItem(undefined); }, className: "btn btn-warning ml-1" },
                    React.createElement(Icon, { name: "pen", className: "mr-1" }),
                    React.createElement("span", null, "Edit")),
                React.createElement(NavLink, { to: "./../..", className: "btn btn-info ml-1" },
                    React.createElement("span", null, "Back to list"))),
            React.createElement(Viewer, { item: item }))),
        error && React.createElement(Alert, { color: "warning" }, error)));
};
var templateObject_1;
//# sourceMappingURL=EntityItemIndexPage.js.map